export const English = {
  translation: {
    pickup: {
      expiredTitle: "Your link has expired",
      expiredDescriptionWithDays:
        "Since it has been {{days}} days since the link was sent, you’ll need to restart your enrollment. This makes sure we provide you with the most accurate information for your circumstance.",
      expiredDescription:
        "This link is no longer valid. Please restart your enrollment so we can provide the most accurate information for your circumstance.",
      newexpireDescription:
        "You'll need to restart your enrollment so we can provide you with the most accurate information.",
      restart: "Restart my enrollment",
      welcome: "Welcome, {{name}}",
      welcomeBack: "Welcome back, {{name}}",
      progressSaved:
        "You’ve already completed most of your enrollment. Just a few quick steps remain, and you'll be all set.",
      fewMoreMinutes: "This should only take a few more minutes.",
      continue: "Continue enrollment",
      scheduledExistingAccount:
        "You're all set! Your appointment is scheduled. Log in below to view the details and manage your account.",
      scheduledNewAccount:
        "You're all set! Your appointment is scheduled. Finish setting up your account below to view your appointment details and manage your account.",
      logInToAccount: "Log In to Account",
      createAccount: "Create Account",
      createAccountTitle: "Create Your LifeSafer Account",
      createAccountDescription:
        "With a LifeSafer Account, you can easily view appointment details, sign documents, and manage payments, all in one convenient place. Create your account today and enjoy a faster, more streamlined experience.",
      createPassword: "Create a password",
      confirmPassword: "Confirm password",
      togglePassword: "Show or hide password",
    },
    europe: {
      welcomeTitle: "Welcome to LifeSafer",
      welcomeDescription:
        "Secure, compliant ignition interlock devices designed to get you back on the road.",
      "GDPR-compliant": "GDPR-compliant",
      Securebydesign: "Secure by design",
      Discreetandeasytouse: "Discreet and easy to use",
      duration: "This process takes approximately 5 minutes to complete.",
      getStarted: "Get Started",
      aboutYouTitle: "About You",
      aboutYouDescription:
        "This helps us confirm we’re a good fit and tailor the information we share. We’ll never send unwanted messages or share your details — your privacy matters to us.",
      violationCountry: "Country of Violation",
      chooseCountry: "Choose country",
      countryRequired: "Country is required",
      registrationCountryRequired: "Registration Country is required",
      registrationNumberRequired: "Registration Number is required",
      completeRequiredFields:
        "Please complete all required fields before continuing.",
      fieldRequired: "{{field}} is required",
      privacyPolicy: "Privacy Policy",
      vehicleTitle: "Vehicle Information",
      whatFeatures: "What features does your car have?",
      vehicleEngineType: "Vehicle engine type",
      vehicleRegistration: "Vehicle Registration",
      registrationCountry: "Registration Country",
      selectRegistrationCountry: "Select a country",
      registrationNumber: "Registration Number",
      enterRegistrationNumber: "Enter a Registration Number",
      licensePlate: "License Plate",
      licensePlateRequired: "License plate is required",
      addressTitle: "Home Address",
      scheduleTitle: "Schedule Your Appointment",
      postalCode: "Postal Code",
      postalCodeRequired: "Postal Code is required",
      postalCodeInvalid: "Postal code is invalid",
      scheduleDescription:
        "Ready to get scheduled? Call the number below and one of our team members will help you find a time that works best for you.",
      callToSchedule: "Call to Schedule",
      contactConsentMessage:
        "We will use the information you provide on this form to respond to your inquiry and communicate with you about your request. By submitting this form, you acknowledge that your data will be processed in accordance with our <privacyPolicy>Privacy Policy</privacyPolicy>.",
    },
    formattedDate: {
      intlDateTimeShort: "{{ date, short }}",
    },
    brandInfo: {
      botName: {
        lifesafer: "Lili",
        monitechnc: "Molly",
        guardianinterlock: "Gabby",
        quickstartaz: "Kelly",
      },
      brandName: {
        lifesafer: "LifeSafer",
        monitechnc: "Monitech",
        guardianinterlock: "Guardian Interlock",
        quickstartaz: "QuickStart",
      },
      brandPhone: {
        lifesafer: "(855) 221-0171", //special phone number for LS installations
        monitechnc: "(800) 521-4246",
        guardianinterlock: "(800) 499-0994",
        quickstartaz: "(888) 717-8278",
      },
      brandPhoneHref: {
        lifesafer: "tel:+1-855-221-0171",
        monitechnc: "tel:+1-800-521-4246",
        guardianinterlock: "tel:+1-800-499-0994",
        quickstartaz: "tel:+1-888-717-8278",
      },
    },
    policies: {
      language: "Language",
      callUs: "Call ",
      termsofUseLabel: "Terms of Use",
      privacyLabel: "Privacy",
      cookiesLabel: "Cookies",
      qualityLabel: "Quality",
      copyrightLabel: "Copyright",
      helpPopupTitle: "Help",
      helpPopupPart1:
        "Let our knowledgeable support team assist you with this enrollment.",
      helpPopupPart2: "Your Session ID: ",
      helpPopupPart3: "Call or Click",
      helpPopupPart4: "Important!",
      helpPopupPart5:
        "Made a mistake? Mistyped something? No worries, you will be able to update all this information at the end of the enrollment in our Client Portal!",
      idleMessageRound1:
        "Enrollment is easy, you're on the way to getting your ",
      idleMessageRound2: "Don't stop now, your ",
      idleMessageRound3: "Your ",
      idleMessage0: "installation",
      idleMessage25: "$25 Credit",
      idleMessage50: "$50 Credit",
      idleMessage100: "$100 Credit",
      idleMessage150: "$150 Credit",
      idleMessage200: "$200 Credit",
      idleMessageUnknown: "installation",
      idleMessageLetsGo: "! Let's Go!",
      idleMessageAwaits:
        " awaits! Scheduling your install appointment is just ahead...",
      idleMessageClose: [
        " is so close, please feel free to reach out to our Expert Support Team to get this wrapped up! Call ",
        ".",
      ],
      callMonitech:
        "Unfortunately we aren't in this state, but good news our partner Monitech does service this state!! Please feel free to reach out to Monitech at (800) 521-4246.",
      notAvailable: [
        "Unfortunately ",
        " doesn't service this state at this time. Please feel free to give us a call if you have questions, ",
        ".",
      ],
      countyQuestionable:
        "For this county we will need you to contact us so we can assist you with enrollment, (800) 634-3077.",
    },
    intro: {
      headerSlogan: "We are committed to your success",
      mailLoader: "We are looking for your information...",
      welcome: [
        "Hello, I'm ",
        ", thanks for choosing ",
        " to assist you with this process. ",
      ],
      fantastic: "Fantastic! ",
      step1: "What is the enrollment code given to you?",
      invalidCode:
        "Hmm... Something doesn't seem right with that enrollment code. How about you try entering it again? Otherwise contact us at ",
      lockoutPart1: "Let's get you some help, your code just isn't working! ",
      lockoutPart2: "Please contact us at ",
      lockoutPart3: " to speak with our expert, 24/7 service team.",
      step1half: [
        "Please tell me in which state were you convicted or volunteering to have a ",
        " device?",
      ],
      step2Part1: [
        "Hello, my name is ",
        " & welcome to ",
        "'s Enrollment Chat. You were referred by ",
      ],
      step2Part2: [", who has partnered with ", " to offer you "],
      step2Part2Add: " a fast & easy way to enroll",
      step2Part3: ". Click the button below to get started!",
      step2ButtonLabel: "Get Started",
      step2halfPart1: "Please let me know what type of device you need? Click ",
      step2halfPart2:
        " for some quick information if you don't know which device you require.",
      step2halfButtonLabel: "here",
      step3:
        "What is your email address or best email address for you? What is your best contact number with area code? ",
      step3Part2: "Previously started enrollment?",
      step3half:
        "We found your email on file with us, so we have sent a verification code to your email to make sure this is you! This code will expire in 10 minutes, please click the button below to enter the code.",
      step3sixth:
        "We found your email on file with us, how would you like to receive your verification code?",
      step3seventh:
        "Please enter the provided verification code and click the continue button.",
      step3seventhExpired:
        "Oh no! Your verification code has expired, click the button below to receive a new code.",
      step3seventhInvalid:
        "Hmm... Something doesn't seem right with that verification code. How about you try entering it again?",
      optInTitle: "GET ENROLLMENT UPDATES TO YOUR PHONE",
      optInBodyPart1:
        "Streamline your installation process. We'll text you updates to help you complete your enrollment and stay up-to-date with your account.",
      optInBodyPart2: [
        "By pressing “Receive Text Updates”, I consent (and provide my digital signature) to receive automated promotional text messages from ",
        " about my enrollment (special offers and coupons may also be sent) at the mobile phone number provided.",
      ],
      optInBodyPart3:
        "Consent not required/condition of purchase. Msg/data rates apply. Reply STOP to opt out (Confirmation will be sent). Reply HELP for help. See our Terms of Use and read our Privacy Policy.",
      optInConfirm: "Receive Text Updates",
      optInCancel: "No Thanks",
      step4:
        "Would you like to use the Quick ID Uploader or manually enter your information? Please note, for the Quick ID Uploader you will need your State ID available for a photo.",
      step4halfPart1:
        "Please either upload a photo or take it with your camera of the ",
      step4halfPart2: "back of your State ID",
      step4halfPart3: ". You can also manually enter it by clicking",
      badUpload:
        "Hmm... We were unable to pull the information from that image. How about you try a new image? Please make sure it's the back of your State ID, otherwise you can easily enter it manually by clicking",
      badUploadPart2:
        "Helpful Hint: You can always take a picture outside of this website, then use our upload section and upload the photo there.",
      badPhotoFile:
        "Unfortunately this not a photo file type please upload another file.",
      step5:
        "What is your legal first name and legal last name, as it appears on your State ID?",
      codeInputLabel: "Enrollment Code",
      codeInputRequired: "Enrollment Code is required.",
      codeInputInvalid: "Invalid enrollment code.",
      noEnrollmentCode: "No Enrollment Code?",
      IIDButtonLabel: "Ignition Interlock Device",
      PAMButtonLabel: "Portable Alcohol Monitor",
      SpeedButtonLabel: "Speed Device",
      devicePopupTitle: " Device Information",
      devicePopupPart1:
        "A small handheld car breathalyzer device that measures the amount of alcohol in the user’s breath. Installing one is a common requirement following a drunk driving offense (DUI, DWI, DUI, OWI, or OVI).",
      devicePopupPart2:
        "A small, portable handheld breathalyzer device that measures the amount of alcohol in the user’s breath. Commonly issued to monitor a user while at home.",
      devicePopupButtonLabel: "Close",
      startedEnrollmentBody:
        "No worries we've got you covered! Just enter your email address you used previously and your phone number and we'll get you back to where you were in the enrollment!",
      startedEnrollmentBodyPart2: "Need help? We'd love to talk call or click ",
      GoogleText1: "This site is protected by reCAPTCHA and the Google ",
      GoogleText2: " and ",
      GoogleText3: " apply.",
      GoogleLink1: "Privacy Policy",
      GoogleLink2: "Terms of Service",
      emailLabel: "Email",
      textLabel: "Text Message",
      textMessageFail:
        "Unfortunately the text message failed to send, so we have sent you an email instead.",
      tooManyAttempts:
        "Unfortunately you have hit our limit on failed verification code attempts!",
      newCodeLabel: "New Verification Code",
      IDUpload: "Quick ID Upload",
      ManualEntry: "Manual Entry",
      firstNameLabel: "Legal First Name",
      lastNameLabel: "Legal Last Name",
      firstNameRequired: "First Name is required.",
      lastNameRequired: "Last Name is required.",
      nameError: "Letters only please.",
      firstNameInvalid: "First Name is invalid",
      lastNameError: "Last Name is invalid",
      emailAddressLabel: "Email Address",
      phoneTypeLabel: "Phone Type",
      phoneNumberLabel: "Phone Number",
      emailAddressRequired: "Email is required.",
      phoneNumberRequired: "Phone Number is required.",
      emailAddressError: "Invalid email address.",
      phoneNumberError: "Valid phone number is required.",
      alreadyRegistered: [
        "This email address can't be used for client enrollment due to it being attached to another ",
        " site.",
      ],
      toVerification: "Enter Verification Code",
      resetCodeInputLabel: "Verification Code",
      resetCodeInputRequired: "Verification Code is required.",
      resetCodeInputInvalid: "Invalid verification code.",
      photoUpload: "Take Photo",
      fileUpload: "Upload Photo",
      instructions: "Instructions",
      photoInstructions:
        "When taking the picture please ensure the ID is as centered as possible. When you're ready click the button below to activate your camera, you may need to allow us this access (popup should appear).",
      computerCamInfo:
        "Note: Many built in laptop webcams may not yield a high enough quality picture for this upload process.",
      fileInstructions:
        "When taking the picture please ensure the ID is as centered as possible. Then click the upload button and pick your image. Accepted formats: .png, .jpg, .jpeg, .heic",
      retake: "Retake",
      upload: "Upload",
      chooseFile: "Choose File",
      newFile: "New File",
      example: "Example",
      communicationsDisclaimer: [
        "* By submitting this form, you agree and consent for ",
        " and its affiliates to use automated technology, including emails, calls, and prerecorded messages, to contact you at the information provided. No purchase necessary.",
      ],
      verificationCode: "Verification Code",
      verificationCodeTitle: "Verify phone number",
      verificationCodeDescription:
        "The entered email already exists in our system with a different phone number. To continue using the entered email please verify your phone with the security code we have sent via text message.",
      submitVerificationCode: "Submit Code",
      verificationCodeRequired: "Verification Code Required.",
      verificationCodeInvalid: "Verification Code Invalid",
      verificationCodeIncorrect:
        "Verification code was incorrect. Please double check and enter again.",
      verificationCodeExpired: "Verification code expired.",
      phoneEmailTitle: "You may already have an account",
      phoneEmailMessage: [
        "We found an existing account with the Name and Phone Number you entered.",
        "Would you like to continue using the email already in our system or the one you just entered?",
      ],
      useExistingEmail: "Use Existing Email",
      useNewEmail: "Use New Email",
      errorSendingText: "Error sending text.",
      contactUs: "Contact Us",
      contactUsMessage:
        "We do not have a cell phone on record for you. Please call us at (800) 634-3077",
      formLeadTextMessage: [
        "Welcome back! It looks like you have already begun the installation scheduling process. To verify your information, we have sent a code through text message to ",
        ". Once verified, you can pick up where you left off.",
      ],
    },
    error: {
      pickBackUpTokenError: [
        "Error validating your token. It is either expired or invalid.",
        "Please contact your service provider.",
      ],
      botMessagePart1:
        "Well this is awkward, we think you could possibly be a bot like me!?!",
      botMessagePart2:
        "Let's get you in touch with our expert support team to get you taken care of!",
      botCallUsButton: "Call Us ",
      botStartOverButton: "Start Over",
      chatMessage:
        "Well, this is awkward and very embarrassing. It looks like my wires got crossed somewhere along the way. What would you like to do?",
      honeyPotError: "Something went wrong, please contact us to assist you",
      noCountyConfigured:"No county is configured for",
    },
    body: {
      startQuestion: "Just a few more questions...",
      dobQuestion: "What is your date of birth?",
      dobLabel: "Date of Birth",
      dobIssue:
        "Hmm, something went wrong in my wiring, please input your date of birth one more time for me!",
      dobRequired: "Date of Birth is required.",
      driverAgeLabel: "Driver's Age",
      driverAgePlaceholder: "Select an age",
      driverAgeRequired: "Driver's Age is required.",
      dobInvalid: "Invalid date format.",
      dobMin: "Date is below the minimum allowed date.",
      dobMax: "Date is above the maximum allowed date.",
      dateFormat: "Format: mm/dd/yyyy",
      happyBDayAddressQuestion:
        "Happy Birthday! What is your home address? To complete this step please start typing in the first line and choose your address, if your address can't be found please type in and select your City and State.",
      homeAddressQuestion:
        "What is your home address? To complete this step please start typing in the first line and choose your address, if your address can't be found please type in and select your City and State.",
      homeAddr1Label: "Address Line 1",
      homeAddr2Label: "Address Line 2",
      homeAddrRequired: "Home Address is required.",
      enterHomeAddress: "Enter your home address",
      licensePlateEntry: "License Plate Entry",
      vehicleInfoEntry: "Vehicle Info Entry",
      homeAddrDirections:
        "You will need to select an address from the autocomplete.  If your address isn't found, enter your city and state in Address Line 1 and select it from the autocomplete.",
      ccsLabel: "City, County, State",
      ccsPlaceholder: "This will be filled in for you!",
      cityLabel: "City",
      cityRequired: "City is required.",
      countyLabel: "County",
      countyPlaceholder: "Select a County",
      countyRequired: "County is required.",
      stateLabel: "State",
      statePlaceholder: "Select a State",
      stateRequired: "State is required.",
      cCStateRequired:
        "State is required. Please enter a valid address or select one from the Address Line 1 dropdown list.",
      cCCityRequired:
        "City is required. Please enter a valid address or select one from the Address Line 1 dropdown list.",
      cCCountyRequired:
        "County is required. Please enter a valid address or select one from the Address Line 1 dropdown list.",
      cantFindState:
        "Not finding the state your looking for? Please contact our support team to get you in touch with one of our partners that does service your state. Call or Click the button below.",
      zipLabel: "Zip",
      zipRequired: "Zip Code is required.",
      zipValid: "A valid Zip Code must be 5 digits in length.",
      addressIssue:
        "Hmm, something went wrong in my wiring, please input your home address one more time for me!",
      IDQuestion: "Great, please enter your State ID information.",
      IDNumberLabel: "Identification Number",
      IDNumberRequired: "Identification number is required.",
      expDateLabel: "Expiration Date",
      expDateValid: "Invalid date format.",
      expDateMin: "Date is below the minimum allowed date.",
      expDateRequired: "Expiration date is required.",
      NoID: "Don't have an ID right now, thats ok we understand this can be part of your local process. Just select the state in which you will have an ID, enter your date of birth and click the continue button.",
      NoIDInfoLink: "Don't have an ID right now? Click ",
      IDInfoLink: "State ID suspended or revoked? Click ",
      IDInfoTitle: "State ID Information",
      IDInfoBody:
        "Dont have an ID right now, thats ok we understand this can be part of your local process. Just select the state in which you will have an ID and click the continue button.",
      IDNotEntered: "I don't have my ID information at this time.",
      IDIssue:
        "Hmm, something went wrong in my wiring, please input your State ID information one more time for me!",
      VINQuestion:
        "Last few pieces of information I need & of course I saved the hardest for last! What is your Vehicle Identification Number? If you don't have this information on hand right now please click the red skip button.",
      VINLabel: "VIN",
      VINRequired: "VIN is required.",
      VINValid: "Valid VIN is required.",
      VINLength: "VIN must be 16 or 17 characters in length.",
      VINConfirmLabel: "Confirm VIN",
      VINConfirmRequired: "VIN Confirmation is required.",
      VINConfirmMatch: "The VINs must match.",
      VINInfoLinkPart1: "Click ",
      VINInfoLinkPart2:
        " for some quick information about your Vehicle Identification Number (VIN).",
      VINInfoLink: "here",
      VINInfoTitle: "VIN Information",
      VINInfoHeader1: "Vehicle Identification Number (VIN)",
      VINInfoHeader2: "Where do I find my VIN?",
      VINInfoPart1:
        "A 16 or 17 character identity code that is made of numbers and letters that identifies your vehicle.",
      VINInfoPart2:
        "Your VIN will be located on your vehicle's dashboard visible through the windshield or it can be found on your vehicle registration paperwork.",
      VINPopupButtonLabel: "Close",
      VINYearLabel: "Year: ",
      VINMakeLabel: "\nMake: ",
      VINModelLabel: "\nModel: ",
      VINNotEntered: "I don't have my VIN information at this time.",
      VINIssue:
        "Hmm, something went wrong in my wiring, please input your VIN one more time for me! If you don't have it click the red skip button.",
      multiVehicleQuestion:
        "Looks like you have a vehicle in our system, could you let me know which one to use?",
      multiVehicleNew: "New Vehicle",
      multiVehicleIssue:
        "Hmm, something went wrong in my wiring, please select one more time for me.",
      licensePlateQuestion: "What is your vehicle's Year, Make, and Model?",
      licensePlateVerification:
        "Is this still your vehicle's Year, Make, and Model?",
      licPlateLabel: "License Plate Number",
      licPlateRequired: "License Plate number is required.",
      licPlateNotEntered:
        "I don't have my License Plate information at this time.",
      licPlateIssue:
        "Hmm, something went wrong in my wiring, please input your vehicle's license plate number and issuing state one more time for me! If you don't have it click the red skip button.",
      vehYearLabel: "Vehicle Year",
      selectVehYearLabel: "Select a Vehicle Year",
      selectEngineTypeLabel: "Select an Engine Type",
      vehYearPlaceholder: "Select a Year",
      vehYearRequired: "Vehicle Year is required.",
      vehMakeLabel: "Vehicle Make",
      vehMakePlaceholder: "Select a Make",
      vehMakeRequired: "Vehicle Make is required.",
      vehModelLabel: "Vehicle Model",
      vehModelPlaceholder: "Select a Model",
      vehModelRequired: "Vehicle Model is required.",
      programTypeQuestion:
        "Last few pieces of information I need. Select your program type.",
      ProgTypeInfoLinkPart2: " for some quick information about Program Types.",
      ProgTypeInfoTitle: "Program Type Information",
      AdminDescription:
        "This type of program is typically assigned by the Motor Vehicle Administration.",
      CourtOrderDescription:
        "The court has ordered you to have a device installed.",
      VoluntaryDescription:
        "Volunteering to have a device installed is a great way to protect yourself and others.",
      PreTrialDescription:
        "This type of program typically means you may not have gone to court or been sentenced yet.",
      ProbationDescription:
        "The court has ordered you to have a device installed because you have been sentenced in 1 or more previous cases.",
      adminButtonLabel: "Administrative",
      courtButtonLabel: "Court Order",
      voluntaryButtonLabel: "Voluntary",
      preTrialButtonLabel: "Pre-Trial",
      probationButtonLabel: "Probation",
      programTypeIssue:
        "Hmm, something went wrong in my wiring, please select your program type one more time for me!",
      deviceLengthQuestion: "How long will you need your device?",
      deviceLengthMonths: "Months",
      deviceLengthIssue:
        "Hmm, something went wrong in my wiring, please let me know how long will you need your device one more time!",
      lossProtectionQuestion:
        "Would you like to include a loss protection plan for your device?",
      lossProtectionInfoLinkPart2:
        " for some quick information about the Loss Protection Plan.",
      lossProtectionInfoTitle: "Loss Protection Plan Information",
      lossProtectionInfoPart1: [
        "", //leave here because of the Spanish translation and how the phare is constructed for it.
        " monitoring devices aren't cheap and we wouldn't want to see you get stuck with the bill if something should happen. The ",
        " Loss Protection Plan avoids this necessary risk of not having protection against the occasionally mishap, we strongly encourage your to protect your device!",
      ],
      lossProtection: "Loss Protection",
      noProtection: "No Protection",
      lossProtectionIssue:
        "Hmm, something went wrong in my wiring, please select your loss protection one more time for me!",
    },
    outro: {
      step1:
        "Whew, we made it! Now let's get your installation appointment scheduled ",
      step1IID: "so we can get you back on the road. ",
      step1PAM: "so you can get your PAM quickly. ",
      step1CallNow: "Schedule Online or give us a Call to Schedule.",
      //"Need an appointment today? Click Call Now To Schedule.",
      scheduleOnlineButton: "Schedule Online",
      callNowButton: "Call Now to Schedule",
      step2:
        "Fantastic, let's get this done! We are looking forward to talking with you, please click or call the phone number below to reach us now!",
      step2one:
        "Hmm.. I can't find a vehicle for you in our system so let's get this done using our expert support team! Please click or call the phone number below to reach us now!",
      step3: [
        "One quick question before we get your appointment scheduled, which vehicle are you having the ",
        " IID installed within?",
      ],
      enterTextBox: "Enter ZIP Code or City, State",
      search: "Search...",
      noLocations:
        "No locations in the selected area, call or click the number below so we can help you with your appointment!",
      searchIssue:
        "Unable to locate this Zip Code or City, State combination. Please try again.",
      searchResults: "Search Results",
      mapInfo: "Map Information",
      partnerLoc: "Preferred Location",
      sameDayLoc: "Same Day Location",
      standardLoc: "Standard Location",
      select: "Select",
      selectedLocation: "Selected Location",
      discountMessagePart1: " - Book Now on a day this icon is",
      discountMessagePart2: "displayed and get an additional $25 Off!*",
      discountDisclaimer: [
        "* By booking your appointment on these dates you will receive an additional $25 Credit to be applied to ",
        " fees. Discount can't be applied towards Labor charges.",
      ],
      noAppointmentsAvail:
        "There are currently no available appointments for this location.",
      backToLocations: "Back to Locations",
      backToCalendar: "Back to Calendar",
      date: "Date",
      time: "Time",
      confirmation: "Confirmation",
      yesButton: "Yes",
      noTimesAvailable: "No Times Available.",
      aptSchedPart1: "You have selected to make an \n appointment on: \n",
      aptSchedPart2: " at ",
      aptSchedPart3:
        "\n for a Installation Service \n at the following location: \n",
      apptSaveSuccess: "Appointment saved.",
      apptSaveFailure: "Appointment save failed, let's try one more time.",
      step4:
        "Thanks for enrolling with me!! This is the last step before I transfer you over to our Client Portal, please create your Client Portal password.",
      password: "Password",
      confirmPassword: "Confirm Password",
      passwordWarning:
        "* Your password must be a minimum of 8 characters and contain at least 1 upper case letter, 1 lower case letter, 1 number, and 1 special character.",
      passwordRequired: "Password is required.",
      passwordValid:
        "Password must be between 8 - 24 characters in length, contain at least 1 upper case letter, 1 lower case letter, 1 number, and 1 special character.",
      confirmPasswordRequired: "Password Confirmation is required.",
      matchPassword: "The password must match.",
      step5: [
        "It looks like you already have an appointment or have a ",
        " device installed! ",
      ],
      step5Part1: {
        lifesafer: "Click the button below to login to the Client Portal.",
        monitechnc: "Click the button below to contact us about your account.",
        guardianinterlock:
          "Click the button below to contact us about your account.",
        quickstartaz:
          "Click the button below to contact us about your account.",
      },
      step5Part2: {
        lifesafer:
          "Within the portal you can view your device information; view, schedule, update, and cancel appointments; view your billing information and make payments; and review and update your personal information.",
        monitechnc: "",
        guardianinterlock: "",
        quickstartaz: "",
      },
      toClientPortal: "Client Portal",
      getHelpTitle: "Talk to the Experts!",
      getHelpPart1:
        "Location or time online not what you need? Let our 24/7 expert team help!",
      thankYou: [
        "Thank you for enrolling with ",
        "! We look forward to seeing you at your upcoming installation appointment.",
      ],
      thankYou1: "If you have any questions please feel free to reach us at ",
    },
    quickLink: {
      header: "Client Referral",
      firstName: "First Name",
      firstNameError: "First Name is required.",
      lastName: "Last Name",
      lastNameError: "Last Name required.",
      cellPhoneNumber: "Cell Phone Number",
      cellPhoneError: "Valid Cell Number is required.",
      sendQuickLink: "Send",
      sendAnother: "Would you like to send another?",
      confirmNewQuickLink: "Yes",
      enrollmentCodeInvalid: [
        "The provided enrollment code : ",
        " is not valid.",
        "Please contact your representative for assistance.",
      ],
      referralSentToast: "Referral sent!",
      clientExists: "Client exists.",
      errorCreatingReferral: "Error creating referral.",
    },
    formLead: {
      queryStringError:
        "The link provided did not contain the required information.",
      header: [
        "Thank you for contacting LifeSafer®.",
        "An expert will be in touch shortly.",
      ],
      subHeader: [
        "Ready to schedule installation?",
        "Skip the wait and schedule online in 5 minutes or less.",
      ],
      previousPage: "Back to previous page",
      nextSteps: "Next steps",
      scheduleInstallation: "Schedule Installation",
      stateQuestion:
        "In which state were you convicted or volunteering to have a LifeSafer device?",
      needAssistance: " Need Assistance? Call us at ",
      learnMore: "Learn more about Monitech",
      // New
      greeting: "Thanks for contacting us,",
      message: "Hang tight! We'll be reaching out to you shortly.",
      save: "SAVE TIME AND MONEY",
      continue: "Continue Online & Save $25 On Your First Payment",
      claim: "Claim My $25 Offer",
      back: "< Back to home",
    },
    steps: {
      buildCodeMessage2: "Expect to hear from us via",
      vehiclePresentMessage:
        "We've found a previously entered vehicle for you in our system, which one would you like to use?",
      newVehicle: "New Vehicle",
      pushStartMessage: `Push a "start" button inside the vehicle`,
      remoteStartMessage: `Start a vehicle using a key fob or app`,
      pushStartLevel: `Keyless "Push" Start`,
      remoteStart: "Remote Start",
      engType: "Engine Type",
      engTypeRequired: "Engine Type is required",
      select: "Select",
      submit: "Submit",
      back: "Back",
      story: "Story",
      continue: "Continue",
      send: "Send",
      welcome: "Welcome",
      myAccount: "My Account",
      start: "Start",
      aboutYou: "About You",
      startMyQuote: "Start My Quote",
      stateInformation: "State Information",
      stateInfo: "State Info",
      vehicleInfo: "Vehicle Info",
      yourVehicle: "Your Vehicle",
      buildMyQuote: "Build My Quote",
      twentyfiveoff: "$25 Off Timer",
      pamShort: "PAM",
      isaShort: "ISA",
      iidShort: "IID",
      devices: "Devices",
      scheduleInstallation: "Installation Scheduled",
      sendEmailTo: "Send Email To",
      appointmentMessage:
        "Your White Glove Team is ready to assist you or log into the My Account site to manage your account.",
      installedMessage:
        "Great News! It looks like you already have a LifeSafer device installed. Click the button below to log into the My Account site to manage your account.",
      buildQuoteSuccess: "Success! We're building your quote now...",
      verificationCode: "Verification Code",
      lossProtectionPlan: "Loss Protection Plan",
      buildCodeMessage1: "Hang tight - this won't take long.",
      buildCodeMessage4:
        "If you have any questions in the meantime, feel free to contact us - we're here to help.",
      buildCodeMessage3:
        "{{ ContactPreference }} in the next 5 minutes or we'll give you $25 off your installation and make sure you get the lowest price available.",
      lppMessage:
        "LifeSafer monitoring devices aren't cheap and we wouldn't want to see you get stuck with the bill if something should happen. The LifeSafer Loss Protection Plan avoids this unnecessary risk of not having protection against the occasional mishap, we strongly encourage you to protect your device.",
      stateMessage:
        "This helps our experts ensure you get your program done as quickly and affordably as possible.",
      welcomeMessage:
        "We'll walk you through your personalized quote - quickly, securely, and with the lowest price available.",
      aboutMessage:
        "This helps us make sure we're good fit and provide the right info. We'll never spam you or share your details - your privacy is important to us.",
      welcomeBackMsg: "Welcome back, you’ve been sent a",
      enterCode: "Please enter the code below.",
      noReceive: "Didn’t receive your code?",
      textCharges: "Depending on your provider, text charges may apply.",
      verificationEmail: "verification email",
      verificationRequired: "Verification Code is Required",
      sendTextMessage: "Send Text Message",
      resendVerification:
        " Resend the verification code or feel free to call us, we are ready to assist you.",
      pickAStoryMessage:
        "To ensure the best possible enrollment experience what is the most important to you?",
      pricingInquiry: "Pricing Inquiry",
      pricingInquiryMessage: "Get the personalized quote you seek quickly.",
      findLocations: "Find Locations",
      findLocationsMessage:
        "Convenience matters, find the closest service center.",
      findInstallationLocation: "Find Installation Location",
      learnMore: "Learn More",
      learnMoreMessage: "Gain knowledge about how LifeSafer can help you.",
      findMyLocation: "Find My Location",
      getMyQuote: "Get My Quote",
      scheduleNow: "Schedule Now",
      scheduleMessage: "Fast track to scheduling your LifeSafer installation.",
      success: "Success",
      personalizedQuote: "Personalized Quote",
      welcomeBack:
        "Welcome Back {{FirstName}}! Our dedicated and knowledgeable support team is ready to assist you with your enrollment. Please feel free to continue your enrollment or call us now.",
      contactMessage:
        "We are looking forward to speaking with you about how LifeSafer can help. Please call now to speak with your state specialist.",
      preferContacted: "How do you prefer to be contacted?",
      emailPlaceholder: "yourname@youremail.com",
      phoneCall: "Phone Call",
      textMessage: "Text Message",
      contactConsentMessage:
        "* By submitting this form, you consent to receive customer care and marketing text messages (e.g. promos, appointment reminders) from LifeSafer at the number provided, including messages sent by automated technology. Consent is not a condition of purchase. Msg & data rates may apply. Msg frequency varies. Unsubscribe at any time by replying STOP or clicking the unsubscribe link (where available).",
      cellNumber: "Cell Number",
      violationState: "State of Violation",
      violationCounty: "County of Violation",
      violationCountyRequired: "County of Violation is required",
      countyRequired: "County is required",
      violationStateRequired: "State of Violation is required",
      whoIsRequiringDevice: "Who is Requiring the Device",
      whoIsRequiringDevicePlaceholder: "Select Required By",
      whoIsRequiringDeviceRequired: "Who is Requiring the Device is required",
      deviceNeeded: "Device Needed",
      deviceNeededRequired: "Device Needed is required",
      deviceRequired: "Device is required",
      deviceNeededPlaceholder: "Select a Device",
      deviceNeededQuestion: "How Long Will You Need the Device",
      deviceNeededQuestionRequired:
        "How Long Will You Need the Device is required",
      iid: "Ignition Interlock Device (IID)",
      iidDescription:
        "A small handheld device that connects to a vehicle's ignition system and measures the amount of alcohol in the user's breath. Installing one is a common requirement following a drunk driving offense (DUI, DWI, OWI, or OVI).",
      pam: "Portable Alcohol Monitor (PAM)",
      pamDescription:
        " A small, portable handled breathalyzer device that measures the amount of alochol in the user's breath. Commonly issued to monitor a user while at home.",
      isa: "Intelligent Speed Assistance (ISA)",
      isaDescription:
        " A solution that helps control your speed by maintaining a fixed top speed limit to ensure you are practicing safe driving habits.",
      stateId: "State ID",
      identificationNumberRequired: "Identification Number is required",
      identificationNumberSelect: "Select a Identification Number",
      comingSoon: "Coming Soon",
      idInfoDescription:
        "Don't have an ID right now? That's ok, we understand this can be part of your local process. Just select the state in which you will have an ID, enter your date of birth and click the continue button.",
      readySupport:
        " The 24/7 {{brand}} Support Team has the experience and knowledge to assist you with your enrollment",
      talkExperts: "Talk to the Experts",
      welcomeMessage1:
        "Thank you for reaching out to LifeSafer to assist you, a trusted partner you can rely on. This enrollment only takes minutes and gets you ready to visit one of our service centers for your easy installation.",
      yourAddress: "Your Address",
      yourAddressDescription:
        "This allows us to match you to the closest and most convenient service center.",
      yourStateId: "Your State ID",
      yourStateDescription:
        "Properly reporting your program is one of our top priorities and it starts with accurate information.",
      yourAddressDescriptionLocation:
        "Your home address allows us to send official notices, reminders, and important documents related to your program requirements.",
      protectionMatters: "Protection Matters",
      scheduleInstallationDescription:
        "Only 1 more minute of your time to schedule your installation appointment online. Or call our dedicated support team that can answer your questions and get you scheduled.",
      accountSetup:
        "Access your information anywhere, anytime online, the LifeSafer My Account site gives you complete access. Please create your password now.",
      selectServiceCenter: "Select Your Service Center",
      selectInstallationDate: "Select Your Installation Date",
      selectInstallationTime: "Select Your Installation Time",
      myAccountSetUp: "My Account Set Up",
      mobileLocation: "Mobile Location",
      milesAway: "Miles Away",
      saving: "Saving",
      homeZip: "Zip Code",
      homePostal: "Postal Code",
      zipInvalid: "Zip Code is Invalid",
      postalCodevalidation: "Postal Code is Invalid",

      pickAStoryMessage1: "How can we help you today?",
      scheduleToday: "Schedule Today",
      scheduleMessage1:
        "Schedule your LifeSafer device installation in just a few minutes.",
      buildAQuote: "Build a Quote",
      buildAQuoteMessage: "Get your personalized quote quickly.",
      findALocation: "Find a Location",
      findALocationMessage: "Find a LifeSafer service center in your area.",
      installationBooked: "Installation Booked!",
      isaInstallationBooked:
        "Your ISA Installation appointment is scheduled for {{appointmentDate}} at {{appointmentTime}}",
      wrapUpDescription1:
        "You will receive a confirmation text with the details of your installation along with reminders leading up to your appointment.",
      wrapUpDescription2:
        " If you have any questions in the meantime, our dedicated service providers are here to help. Give us a call at (833) 396-8034 at any time for assistance.",
      wrapUpDescription2Mobile:
        " If you have any questions in the meantime, our dedicated service providers are here to help. Give us a call at (833) 396-8034 at {{anyTime}} for assistance.",
      thankYouIsa: "Thank you for choosing LifeSafer ISA.",
      lookForward:
        "We look forward to partnering with you to protect what matters most.",
      buildAQuoteReadyDescription:
        "Our Team is available right now to walk you through all of the details. Call or click the number below to speak with your state specialist.",
      buildAQuoteReadyTitle: "Your Quote is Ready to Go!",
      buildAQuoteReadyTitlePilot: "Your Quote is on the way!",
      quoteOnWayTextMessage:
        "One of our State Specialists is preparing your quote now and will send it to your mobile device for quick and easy access. Look for a text from us to review your personalized pricing information shortly.",
      confirmDescription:
        "We'll place a small temporary charge to verify your card. Once confirmed, your account will be setup for secure, automatic monthly payments.",
      chooseThisDevice: "CHOOSE THIS DEVICE",
      lifeSaferLocation: "Find a LifeSafer Location Near You",
      selectLocationTitle: "Select a location",
      selectLocationDescription:
        "Pick your location so we can give you the most accurate quote.",
      zipOrCityState: "Zip Code or City, State",
      enterZipOrCityState: "Enter Zip Code or City, State.",
      googleMapsNotReady: "Google Maps is not ready yet.",
      noMatchingLocationFound: "No matching location found.",
      unableToLoadLocation: "Unable to load location.",
      savingYourLocation: "Saving your location...",
      loading: "Loading...",
      quoteReady: "Success! Your Quote is Ready",
      quiteHourTitle1: "Thanks for Requesting Your Quote",
      quiteHourDes1:
        "Since your request came in outside of permitted calling hours, we're unable to respond at this time. We'll follow up as soon as we're able while respecting required contact restrictions.",
      quiteHourDes2:
        "If you'd like help now, our team is here and ready to connect.",
      quiteHourButton1: "CONNECT WITH AN AGENT NOW",
      quiteHourButton2: "VIEW MY QUOTE",
      quiteHourDes3:
        "Your quote is ready to view. We'll send the link again in the morning, just to make things easy.",
      quiteHourDes4:
        "If you'd like help now, our team is here and ready to chat.",
      quiteHourDes12:
        "Since your request came in outside of permitted texting hours, we're unable to respond at this time. We'll follow up as soon as we're able while respecting required contact restrictions.",
      quiteHourButton5: "CHAT WITH AN AGENT NOW",

      stateCityCountyRequired: "State, City, County is required",
      addressRequired: "{{addressRequired}}",
      generatingQuote: "Generating Quote",
      getExpertHelp: "Get Expert Help",
    },
    speed: {
      close: "Close",
      learnMoreMessage: "Discover how ISA can enhance your teen's road safety",
      tapPicture: "Tap on each picture below to learn More",
      hoverPicture: "Hover on each picture to learn More",
      activeSpeedControl: "Active Speed Control",
      activeSpeedControlDescription:
        "LifeSafer ISA keeps you within posted speed limits using active speed control, customized speed settings, and real-time GPS monitoring.",
      accelerationControl: "Acceleration Control",
      accelerationControlDescription:
        "Prevent reckless acceleration in forward motion or reverse. Our device includes RPM-limiting features that smooth out fast takeoffs and sudden speed changes.",
      tamperDetection: "Tamper Detection",
      tamperDetectionDescription:
        "If the device is removed or altered, notifications will go out right away, keeping everyone in the loop and your program on track.",
      temporaryOverride: "Temporary Override",
      temporaryOverrideDescription:
        "For unexpected situations, LifeSafer ISA includes a temporary override feature that allows momentary disengagement of the device. You set the rules with customizable time and usage limits.",
      digitalDisplays: "Digital Displays",
      digitalDisplaysDescription:
        "See what matters at a glance with a real-time digital display that shows your current speed, the posted speed limit, and color-coded alerts for upcoming speed limit changes.",
      next: "Next",
      buildSafeTitle: "Build Safe Driving Habits from Day One",
      buildSafeSubtitle:
        "In the first six months, teens are at the highest risk on the road.",
      reinforceSafeTitle: "Reinforce Safe Habits as Teens Gain Experience",
      reinforceSafeSubtitle:
        "After their first six months of driving, confidence grows—but so can risky behavior.",
      passiveTitle: "Passive Limiting",
      passivePoint1: "warns driver",
      passivePoint2: "may set a maximum speed",
      passivePoint3: "doesn't actually stop speeding",
      activeTitle: "Active Limiting",
      activePoint1: "keeps the car within the posted limit",
      activePoint2: "prevents speeding before it starts",
      paragraphInexperienced1:
        "With passive speed limiting, a teen can still push past alerts or develop unsafe habits. But active speed limiting, like LifeSafer ISA, removes the temptation to speed and helps them build safe habits from day one—giving you real peace of mind.",
      paragraphInexperienced2:
        "For new drivers, LifeSafer ISA’s Active Speed Limiting offers the safest, most consistent protection.",
      paragraphExperienced1:
        "With passive speed limiting, a teen can still push past alerts or develop unsafe habits. But active speed limiting, like LifeSafer ISA, removes the temptation to speed and helps them rebuild safe habits.",
      paragraphExperienced2:
        "For new drivers, LifeSafer ISA’s Active Speed Limiting offers the safest, most consistent protection.",
      howIsa: "How ISA Reinforces Safe Habits",
      enrollNow: "ENROLL NOW",
      backTo: "BACK TO",
      lifesaferISA: "LIFESAFERISA.COM",
      readyDescription1:
        "If you have any questions in the meantime, our dedicated service providers are here to help. Give us a call at (833) 396-8034 at any time for assistance.",
      readyDescription1Mobile:
        "If you have any questions in the meantime, our dedicated service providers are here to help. Give us a call at (833) 396-8034 at {{anyTime}} for assistance.",

      readyDescription2:
        "You've taken an important step toward keeping your teen safe on the road. We'll stay in touch so you can take the next step when the time is right.",
      readyDescription3:
        " Let’s schedule your appointment now. It takes as little as one hour to install an ISA device in your vehicle.",
      readyDescription4:
        "Need more time? That’s okay too—you can save your info and schedule when you’re ready.",
      takeYourTime: "You're All Set - Take Your Time",
      readyNextStep: "Ready to Take the Next Step?",
      allSet: "All Set?",
      scheduleLater: "Schedule Later",
      saveScheduleLater: "Save & Schedule Later",
      selectPlan: "SELECT THIS PLAN",
      save: "SAVE",
      viewDetails: "VIEW DETAILS",
      learnMoreTitle: "Drive Smart, Stay Safe",
      driverTitle: "Driver Experience",
      driverDescription:
        "These 3 quick questions help us tailor your ISA program to best fit your driver’s needs.",
      pricingTitle: "Choose Your Safety Program",
      Q: "Q",
      introductionText1:
        "Every time your teen driver gets behind the wheel, speed becomes a risk.",
      introductionText2:
        "What if you could reduce that risk with <strong> <u>one simple decision?</u> </strong>",
      introductionText3:
        "Introducing <strong> LifeSafer Intelligent Speed Assistance (ISA),</strong> the simple choice for parents that protects every drive.",
      introductionText4:
        "LifeSafer ISA keeps your teen within safe speed limits, helping reduce risk from the moment they start the car.",
      selectAnswer: "Please select an answer.",
      allQuestionsIncomplete:
        "Please select an answer for the questions below.",
      oneQuestionIncomplete:
        "Please select an answer for question {{questionNumber}}.",
      twoQuestionsIncomplete:
        "Please select an answer for questions {{questionNumbers}}.",
      answerRequired: "Answer required",
      and: "and",
      pro: "Pro",
      realTimeSpeed: "Real-time speed limiter",
      realTimeSpeedDescription:
        "Prevents the vehicle from exceeding posted speed limits. Unlike systems that only issue warnings, this feature actively restricts speed in real time.",
      configurableTopLimits: "Configurable top limits",
      accelerationReverseControl: "Acceleration and reverse control",
      accelerationReverseControlDescription:
        "Restricts sudden acceleration and unsafe reversing maneuvers, helping to reduce the likelihood of high-risk driving behavior.",
      goalTraining: "Goal-driven training",
      goalTrainingDescription:
        "Provides a framework for setting measurable driving goals, supporting the development of safe driving habits over time.",
      dedicatedCustomerService:
        "Dedicated customer service, 24/7, 365 days a year",
      dedicatedCustomerServiceDescription:
        "Support is available at any time for assistance with setup, troubleshooting, or general questions.",
      freeInstallation: "Free installation",
      configurabletTopSpeedLimit: "Configurable top speed limits",
      configurabletTopSpeedLimitDescription:
        "Allows adjustment of maximum speeds, alert thresholds, and operating mode (active or passive). Settings can be updated as the driver gains experience.",
      driverReport: "Driver report card",
      driverReportDescription:
        "Delivers clear summaries of driving activity, including patterns such as speeding, harsh acceleration, and hard braking, to help identify areas that may require improvement.",
      freeInstallationCost: "Free installation with no added cost",
      freeInstallationCostDescription:
        "Professional installation is handled by an authorized shop at your expense, and LifeSafer provides a $150 account credit toward your next bill to cover the cost.",
      priceLockGuarantee: "Price lock guarantee",
      priceLockGuaranteeDescription:
        "Enjoy long-term peace of mind knowing your monthly ISA rate is locked in for the full 24-month term of your plan. Applies to the then-current base monthly service rate charged by LifeSafer. Excludes taxes, fees, surcharges, optional add-ons, or discounts. Guarantee is void if service is canceled, suspended, or moved to an ineligible plan. Taxes, fees, surcharges, and optional services are subject to change.",
      priceLockGuaranteeDescription2:
        "Keep your budget predictable with a guaranteed monthly rate locked in for the entire 12-month term of your plan. Applies to the then-current base monthly service rate charged by LifeSafer. Excludes taxes, fees, surcharges, optional add-ons, or discounts. Guarantee is void if service is canceled, suspended, or moved to an ineligible plan. Taxes, fees, surcharges, and optional services are subject to change.",
      priceLockGuaranteeDescription3:
        "Stay flexible while keeping your monthly rate locked in for the length of each billing cycle. Applies to the current base monthly service rate charged by LifeSafer. Taxes, fees, and optional services may still change.",
      copilot: "Copilot",
      billedMonthly1: "$99.99/month, billed monthly.",
      billedMonthly2: "$129.99/month, billed monthly.",
      billedMonthly3: "$199.99/month, billed monthly.",
      priceLockGuarantee1: "2-year price lock guarantee",
      priceLockGuarantee2: "1-year price lock guarantee",
      priceLockGuarantee3: "Cancel at any time, on your terms.",
      kickstart: "Kickstart",
      submit: "Submit",

      //newly added for Driver enrollment form
      howExperienced: "How experienced is your driver?",
      hasNotDriven: "Hasn't driven yet",
      zeroto3: "0-3 months",
      threeto6: "3-6 months",
      sixto12: "6-12 months",
      oneyearPlus: "1+ year",

      whyInterested: "Why are you interested in ISA?",
      developHabits: "Develop good habits",
      ticketAccident: "Ticket/crash",
      protection: "Protection",
      peaceOfMind: "Peace of mind",
      other: "Other",

      howSoon: "When are you looking to get an installation?",
      asSoon: "As soon as possible",
      next30: "Next 30 days",
      thirtyto60: "30-60 days",
      sixtyplus: "60+ days",
      undecided: "Undecided",

      autoPaySignupTitle: "Auto Pay Sign-Up",
    },
    //New Enrollment Front V2 Added By Ankit
    navigation: {
      returnTo: "Return to",
      lifesafer: "Lifesafer.com",
      lifesaferisa: "Lifesaferisa.com",
      assistMessage:
        "Let our knowledgeable support team assist you with this enrollment",
    },
    toasts: {
      updateComplete: "Update complete.",
      updateFailed: "Update failed.",
      deleteNotification: "Notification deleted.",
      messageDeleted: "Message deleted.",
      messageUpdated: "Message updated.",
      messageCreated: "Message created.",
      error: "An Error has occurred!",
      uploadComplete: "Upload complete.",
      uploadFailed: "Upload failed.",
      saving: "Saving.",
      textSent: "Text Message sent.",
      textError: "Error sending text message.",
      emailSent: "Email sent.",
      emailError: "Error sending email.",
      userCreated: "User created.",
      userCreationFailed: "User creation failed. ",
      emailReset: "Email Reset Successfully",
      duplicateData: "Duplicate data found.",
      createComplete: "Create complete.",
      createFailed: "Create failed.",
      warning: "Please update one field prior to clicking the Update button.",
      locationRequired: "Location is Required",
      messageSent: "Message sent successfully",
      messageSentFailed: "Failed to send message",
      emailSentSuccess: "Email sent successfully",
      emailSentFailed: "Failed to send email",
      refreshedSuccessfully: "Refreshed Successfully",
      vehicleAdded: "Vehicle added successfully",
      codeSentSuccess: "Verification Code Sent Successfully",
      errorMessage: "An error has occurred, let's try this again.",
      noLocationPayment: "This location has not been setup for online payment.",
      cardUpdatedMessage: "Card updated successfully.",
      cardSuccessMessage: "Card added successfully.",
    },
    payments: {
      acceptedPayMethods: "Accepted Payment Methods",
      paymentMethod: "Payment Method",
      endingIn: "Ending In:",
      redoMessage: "You will need to revalidate card information.",
      zipCode: "Zip Code",
      cardNumber: "Card Number",
      expDate: "Expiration Date",
      autoPaySignUpMessage:
        "By submitting your credit or debit card information on this page and checking this box, you are authorizing us to charge this card pursuant to the Terms and Conditions of your Program Service Agreement.",
      autoPayEnroll: "Enroll in Auto Pay",
      zipCodeError: "Invalid Zip Code, please correct.",
      cardNumberError: "Invalid Card Number, please retry.",
      cvv2Error: "Invalid CVV2, please correct.",
      expDateError: "Invalid Expiration Date, please correct.",
      verifyButton: "Verify",
      confirmation: "Confirmation",
      autoPayMessage:
        "By checking this box confirm with the client that they are authorizing LifeSafer to charge this card pursuant to the Terms and Conditions of their Program Service Agreement.",
      ccVerificationError: "There was a problem verifying this payment method.",
      finishBooking: "Finish Booking",
    },
    location: {
      device: "Device",
      programLength: "Program Length",
      programLengthRequired: "Program Length is required",
      stateInfo: "State Info",
      helpsState:
        "This helps our experts ensure you get your program done as quickly and affordably as possible.",
      stateOpt1: "I opt-in to LifeSafer’s Loss Protection Plan.",
      stateOpt2:
        "I opt-out of LifeSafer’s Loss Protection Plan and acknowledge that I may be responsible for the cost of the device if damaged.",
      welcomeLifesafer: "Welcome to LifeSafer",
      deviceSchedule:
        "Let's get you scheduled. First, what device do you need?",
      chooseDeviceType: "Choose device type...",
      bookAppointment: "Book Appointment",
      enterZipCode: "Enter the Zip Code",
      nolLocations: "No Locations in the selected area. ",
      zipLabel: "ZIP or City, State",
      scheduleYourAppointment: "Schedule Your Appointment",
      scheduleMyAppointment: "Schedule My Appointment",
      lifesaferShop: "Your LifeSafer Shop",
      scheduleLike: "What day would you like to schedule?",
      installationTime: "Installation typically takes 60-90 minutes.",
      moreDate: "View More Dates",
      availableAppointment: "Available appointment times",
      whatIsThis: "What is this?",
      lossProtectionTitle: "LifeSafer Loss Protection Plan",
      lossProtectionDescription:
        "Replacing your monitoring device can be costly. The LifeSafer Loss Protection Plan saves you from that expense and protects you against the occasional mishap. We strongly encourage you to protect your device.",
      exit: "EXIT",
      county: "County",
      enrollmentCode: "Enrollment Code",
      enrollmentDescription1:
        "Enrollment codes are typically given by partners, court systems, probation officers and DMVs.",
      enterCode:
        "Please enter the code exactly as it is displayed on your document.",
      dontRememberEnrollment:
        " If you don't remember your enrollment code, or you don't have one, just enter who sent you to us.",
      hearAboutHowLong:
        "Let us know how you found us. Whether it was through a search engine, a recommendation from an attorney, social media, or another source, your answer helps us improve our client experience.",
      or: "OR",
      hearAboutUs: "Where did you hear about us?",
      chooseOne: "Choose one...",
      whoReferred: "Who or what referred you?",
      enterName: "Enter a name, organization, or website",
      hearAboutNameRequired: "Hear About Name is required",
      submit: "Submit",
      skip: "SKIP",
      gotEnrollmentCode: "Got an Enrollment Code?",
      state: "State",
      chooseState: "Choose state...",
      stateRequired: "State is Required",
      haveAnId:
        "Don't have an ID right now? Select the state in which you will have an ID, enter your date of birth and click the continue button.",
      yourStateId: "Your State ID",
      booked: "You’re booked!",
      confirmationSent: "Your confirmation will be sent out shortly.",
      at: "at",
      youWillBeGoing: "You’ll be going to",
      calendar: "Calendar",
      googleCalendar: "Google Calendar",
      appleCalendar: "Apple Calendar",
      outlookCalendar: "Outlook Calendar",
      createAccount: "Create Your LifeSafer Account",
      finalConfirmationDescription:
        "With a LifeSafer Account, you can easily view appointment details, sign documents, and manage payments, all in one convenient place. Create your account today and enjoy a faster, more streamlined experience.",
      addTo: "Add to",
      createPassword: "Create a password",
      confirmFinalPassword: "Confirm password",
      password: "Password",
      createAccountBtn: "CREATE ACCOUNT",
      iCalFile: "iCal File",
      installDevice: "to install an {{deviceType}} in your",
      installDevicePAM: "to install a {{deviceType}}.",
      sessionExpired: "Session is Expired",
      moreLocations: "MORE LOCATIONS",
      moreTimes: "MORE TIMES",
      trimLevel: "Trim Level",
      trimLevelPlaceholder: "Select a Trim Level",
      trimLevelRequired: "Trim Level is required",
      noAvailableDates:
        "There are currently no appointment dates for this location. Please try another location or check back later.",
      noAppointmentReserved: "Appointment is no longer reserved",
      clickHere: "Click here",
      restartAppointment: "to restart your enrollment",
      appointmentReserved: "Appointment reserved for",
      deviceUpdateMadeTitle: "Device Update Made",
      deviceUpdateMadeDescription:
        "It looks like you have changed your Device which could cause potential issues with the appointment you selected. Let's make sure your appointment date and time are still good.",
      confirmAppointment: "CONFIRM APPOINTMENT",
      cancel: "CANCEL",
      pam: "PAM",
      noLocation: "No locations in the selected area",
      openAfter: "Open after 5pm",
      openWeekends: "Open on weekends",
      appointmentsToday: "Appointments today",
      morning: "Morning",
      afternoon: "Afternoon",
      evening: "Evening",
      preferredShop: "PREFERRED SHOP",
      lifesaferInstallationLoc: "LifeSafer Installation Locations",
      confirmPasswordValid: "The password must match.",
      passwordRequired: "Password is required.",
      confirmPasswordRequired: "Password Confirmation is required.",
      passwordPattern:
        "Password must be between 8 - 24 characters in length, contain at least 1 upper case letter, 1 lower case letter, 1 number, and 1 special character.",
      courtOrdered: "Court Ordered",
      volunteer: "Volunteer",
      courtOrderedDescription:
        "I am ordered to install an Intelligent Speed Assistance (ISA) device in my vehicle.",
      volunteerDescription:
        "I want to install an Intelligent Speed Assistance (ISA) device in my teen's vehicle.",
      situation: "Which best describes your situation?",
      whatFeatures: "What features does your car have?",
      getStarted: "Get Started",
      myShop: "My shop",
      setAsMyShop: "Set as my shop",
      fleet: "Fleet",
      fleetDescription:
        "I'm interested in Intelligent Speed Assistance (ISA) for a fleet of vehicles.",
      deviceTypeRequired: "Device Type is required",
      hearAboutHow: "How did you hear about us?",

      welcomeHeading: "Schedule Your Appointment at {{serviceCenterName}}",
      welcomeTitleOne:
        "Getting your installation appointment scheduled only takes about 5 minutes.",
      welcomeTitleTwo: "What we'll take care of:",
      welcomeTitleThree: "Confirm your setup",
      welcomeDescriptionThree:
        "Quick details about you, your state requirements, and your vehicle (if necessary)",
      welcomeDescriptionThreePam:
        "Quick details about you and your state requirements, and your vehicle (if necessary)",
      welcomeTitleFourDescription:
        "Help you lock in an appointment at {{serviceCenterName}}",
      welcomeTitleFive: "End-to-end guidance",
      welcomeTitleFiveDescription:
        "Provide clear instructions on what to expect next",
      compliance: "Compliance",
    },
    partner: {
      offenseState: "State of violation",
      offenseStateRequired: "State of violation is required",
      offenseCounty: "County of violation",
      offenseCountyRequired: "County of violation is required",
      welcomeLifesafer: "Welcome to LifeSafer",
      programDetails: "Program Details",
      programDetailsDescription:
        "This helps us confirm your eligibility and make sure everything is set up correctly for your state.",
      vehicleDescription:
        "Tell us about your vehicle so we can provide you with the best installation experience.",
      homeAddress: "Home address",
      homeAddressDescription:
        "Your Home Address allows us to send official notices, reminders, and important documents related to your program requirements.",
      stateDescription:
        "Properly reporting your program is one of our top priorities, and it starts with accurate information.",
      inactivityScreenTitleOne: "Getting Started Is Easy",
      inactivityScreenDescriptionOne:
        "You're at the beginning of enrollment — and we'll guide you every step of the way.",
      inactivityScreenCardOne:
        "<strong>Hundreds of thousands of drivers</strong> have completed their program with LifeSafer.",
      inactivityScreenCardTwo:
        "Trusted by partners nationwide, we focus on <strong>clear expectations, reliable service, and fewer surprises</strong> — so you can move forward with confidence.",
      inactivityScreenTitleTwo: "You're Making Great Progress",
      inactivityScreenDescriptionTwo:
        "You're halfway through enrollment — just a few more steps to go.",
      inactivityScreenCardThree:
        "Designed to be <strong>compact,clear, </strong>and <strong>easy to use </strong>from day one.",
      inactivityScreenCardFour:
        "With a <strong>discreet size</strong> and <strong>smart on-screen guidance,</strong> our device helps you <strong>stay informed and avoid confusion</strong> throughout your program.",
      inactivityScreenTitleThree: "You're Almost Done",
      inactivityScreenDescriptionThree:
        "Finish enrollment now to start your {{deviceType}} program.",
      inactivityScreenCardFive:
        "We have <strong>nearby service centers across {{matchedStateName}}</strong>,so scheduling and ongoing care fit <strong>easily into your routine.</strong>",
      inactivityScreenCardSix:
        "With LifeSafer, you get {{deviceType}} installation <strong>without long drives or limited availability.</strong>",
      welcomeTitleOne:
        "We work directly with {{partnerName}} to help you complete your state requirements.",
      welcomeTitleTwo:
        "As a referred client, we'll fast-track your enrollment and ensure your setup is handled seamlessly.",
      welcomeTitleThree: "The entire process only takes a few minutes.",
      welcomeTitleFour:
        "The entire process only takes a few minutes, and we will take care of:",
      welcomeTitleFive: "What we will take care of:",
      referedToLifeSafer: "Referred to LifeSafer by {{partnerName}}",
      welcomeStepTitleOne: "Confirm your setup",
      welcomeStepDescriptionOne:
        "Quick details about you, your state requirements, and your vehicle (if necessary)",
      welcomeStepDescriptionOnePam:
        "Quick details about you and your state requirements, and your vehicle (if necessary)",
      welcomeStepTitleTwo: "Coordinate installation",
      welcomeStepDescriptionTwo: "Schedule at a convenient location near you",
      welcomeStepTitleThree: "Handle your referral benefits",
      welcomeStepDescriptionThree:
        "Apply any discounts and outline your next steps clearly",
      genericTrustedBanner:
        "Trusted by courts and supervision agencies across the U.S.",
      genericWelcomeIntroOne:
        "Courts and supervision agencies nationwide trust LifeSafer to help drivers meet state requirements with confidence.",
      genericWelcomeIntroTwo:
        "We'll guide you through enrollment, installation, and reporting to help ensure a smooth, compliant experience from start to finish.",
      genericWelcomeTakeCareTitle: "What we'll take care of:",
      genericWelcomeStepDescriptionOne:
        "Quick details about you, your state requirements, and your vehicle (if necessary)",
      genericWelcomeStepTitleThree: "End-to-end guidance",
      genericWelcomeStepDescriptionThree:
        "From enrollment to deinstallation, we've got you covered",
      offenseStateDescription:
        "Please make sure this is the state in which the violation occurred. This may or may not be the same state you live in.",
      continueEnrollment: "Continue My Enrollment",
      partnerDescription:
        "Properly reporting your program is one of our top priorities, and it starts with accurate information.",
      inactivityScreenNote: "What does the LifeSafer device look like?",
      aboutPartner:
        "Initiate your enrollment and select your preferred contact method.",
      programDetailsPartnerDesp:
        "This helps us confirm your eligibility and make sure everything is set up correctly for your state.",
      vehicleDescriptionPartner:
        "Tell us about your vehicle so we can provide you with the best installation experience.",
      addressDescriptionPartner:
        "Your home address allows us to send official notices, reminders, and important documents related to your program requirements.",
      idDescriptionPartner:
        "Properly reporting your program is one of our top priorities, and it starts with accurate information.",
    },

    partnerPricing: {
      allSetTitle: "You're All Set",
      allSetDescriptionPartner:
        "{{partnerName}} referred you here so you'd have a clear and predictable experience. We'll show you exactly what's included and what to expect throughout the program. No hidden fees, no guesswork.",
      allSetDescription:
        "Your partner referred you here so you’d have a clear and predictable experience. We’ll show you exactly what’s included and what to expect throughout the program. No hidden fees, no guesswork.",
      installationCostLabel: "Installation Cost",
      programCostLabel: "Program Cost",
      pricingOverviewTitle: "Your Pricing Overview",
      partnerReferralDiscountTitle: "Partner Referral Discount",
      partnerReferralDiscountDescription:
        "Savings applied thanks to your referral from {{partnerName}}. Credit applied automatically to your account.",
      oneTimeInstallationCostTitle: "One-Time Installation Cost",
      oneTimeInstallationCostDescription:
        "Paid directly to the service center as a labor fee at the time of install. LifeSafer does not charge any additional installation fees.",
      programCostBiWeeklyTitle: "Program Cost (Every 2 weeks)",
      programCostBiWeeklyDescription:
        "Device lease, monitoring, and required reporting.",
      questionsBeforeAppointment: "Questions before your appointment?",
      questionsHelpPrefix: "We're here to help. Call or text us at",
      questionsHelpSuffix: ", or chat anytime.",
      scheduleAppointmentCta: "SCHEDULE APPOINTMENT",
      scheduleAppointmentTitle: "Schedule Appointment",
      scheduleAppointmentDescription:
        "Choose your appointment location, date, and time.",
      whatToExpectNextTitle: "What to Expect Next",
      attendAppointmentTitle: "Attend Your Appointment",
      attendAppointmentBullet1:
        "Bring your required documentation to your scheduled appointment.",
      attendAppointmentBullet2:
        "Your service center will install the device and walk you through how it works.",
      supportComplianceTitle: "Ongoing Support & Compliance",
      supportComplianceBullet1:
        "After installation, we'll support you with monitoring, state reporting, and reminders so staying compliant is simple.",
      understandingPricingTitle: "Understanding Your {{deviceType}} Pricing",
      yourPartnerDiscountTitle: "Your Partner Discount",
      yourPartnerDiscountDescription:
        "You've received a {{discountAmount}} partner credit from {{partnerName}}, already applied to your first month's payments.",
      atInstallationTitle: "At Installation",
      atInstallationDescription:
        "A one-time installation cost paid directly to your local service center during your appointment.",
      programCostTitle: "Program Cost",
      programCostDescriptionPrefix:
        "A recurring device and monitoring charge that covers:",
      programCostBullet1: "your {{ deviceType }} device",
      programCostBullet2: "required state reporting",
      programCostBullet3: "monitoring and compliance support",
      programCostBullet4: "device calibration when applicable",
    },
  },
};
